let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("58s7b")).then(() => parcelRequire('28Pju'));